export default class Copy {
  constructor(links) {
    if (!links || links.length === 0) {
      return;
    }

    links.forEach(link => {
      this.copyHandler(link);
    })
  }

  /**
   * Copy Handler,
   * @param link
   */
  copyHandler(link) {

    link.addEventListener('click', (event) => {
      event.preventDefault();

      const id = link.dataset.target;
      if (!id) {
        return;
      }

      const field = document.getElementById(id),
        notification = document.querySelector(`.copy-alert[data-copy="${id}"]`);

      // Copy inner text of the input
      field.select();
      field.setSelectionRange(0, 99999);
      document.execCommand("copy");

      // Add notification for the user
      notification.classList.add('copy-alert--active');

      // Remove notification after 2 seconds
      setTimeout(function () {
        notification.classList.remove('copy-alert--active');
      }, 2000);
    });
  }
}
